import { Runtime, useContentModule } from '@silvertours/front-entities';
import { TrustWrapper } from './TrustSeals.styles';
import { Trustpilot } from './TrustElements/Trustpilot';

type TrustSealsProps = {
  hasStageAbove?: boolean;
  isModernStage?: boolean;
  isPlainTemplate?: boolean;
};

const TrustSeals = ({
  hasStageAbove = true,
  isModernStage = false,
  isPlainTemplate = false,
}: TrustSealsProps) => {
  const { language } = Runtime.useLocale();

  const { getTrustpilotData } = useContentModule();
  const trustpilotProps = getTrustpilotData();

  if ((language !== 'de' && language !== 'fr') || !trustpilotProps) {
    return null;
  }

  return (
    <TrustWrapper
      isPlainTemplate={isPlainTemplate}
      hasStageAbove={hasStageAbove}
      isModernStage={isModernStage}
    >
      <Trustpilot {...trustpilotProps} />
    </TrustWrapper>
  );
};

export { TrustSeals };
